import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../config";

function VerifyEmailPage() {
  const { token, type } = useParams(); // Support optional type parameter
  const navigate = useNavigate();
  const [message, setMessage] = useState("Verifying your email...");
  const [error, setError] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        // Only include type in the payload if it exists
        const payload = { token };
        if (type) {
          payload.type = type;
        }

        const res = await axios.post(
          `${API_BASE_URL}/verify-email`,
          payload,
          { withCredentials: true }
        );

        if (res.data.success) {
          setMessage("Email verified successfully! Redirecting to login...");
          setTimeout(() => navigate("/login"), 2500);
        } else {
          setError(res.data.message || "Verification failed.");
        }
      } catch (err) {
        setError("Something went wrong. Please try again later.");
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-5 col-12">
          <div className="inbx formbxx">
            <div className="frmtbx">
              <h2 className="mb-2 text-center fw700 pb-3 mb-3">
                <i class="bi bi-envelope-check-fill"></i> Email Verification
              </h2>
            </div>
            {error ? (
              <div className="alert alert-danger">{error}</div>
            ) : (
              <div className="alert alert-info">{message}</div>
            )}
            <div className="mt-3 text-center">
              <a href="/login" className="btn btn-success w-100">
                Go to Login
              </a>
            </div>
          </div>
        </div>
        <div className="col-md-7 col-12 gx-0 limgcn">
          <img src="/log-bg.png" alt="Logo" className="login-bg" />
        </div>
      </div>
    </div>
  );
}

export default VerifyEmailPage;
